
import { createContext, useContext, useState } from 'react';

interface EmailLogsContextType {
  totalRecords: number;
  setTotalRecords: (value: number) => void;
}

const EmailLogsContext = createContext<EmailLogsContextType | undefined>(undefined);

export const EmailLogsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [totalRecords, setTotalRecords] = useState<number>(0);

  return (
    <EmailLogsContext.Provider value={{ totalRecords, setTotalRecords }}>
      {children}
    </EmailLogsContext.Provider>
  );
};

export const useEmailLogs = () => {
  const context = useContext(EmailLogsContext);
  if (context === undefined) {
    throw new Error('Email logs must be used within a EmailLogsProvider');
  }
  return context;
};